module.exports = __webpack_public_path__ + "4e8595be3ceacf3081305e4387407d57.jpg";